import { render, staticRenderFns } from "./relevance.vue?vue&type=template&id=46fc889a&scoped=true&"
import script from "./relevance.vue?vue&type=script&lang=js&"
export * from "./relevance.vue?vue&type=script&lang=js&"
import style0 from "./relevance.vue?vue&type=style&index=0&id=46fc889a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc889a",
  null
  
)

export default component.exports